const skillGroups = [
  {
    id: "languages",
    label: "Languages",
    accent: "violet",
    items: ["Python", "C#", "TypeScript", "SQL", "JavaScript", "HTML/CSS"]
  },
  {
    id: "frameworks",
    label: "Frameworks & Tools",
    accent: "teal",
    items: [".NET", "Angular", "Vitest", "Jasmine", "MCP", "Unity", "Git", "CI/CD (Azure DevOps)"]
  },
  {
    id: "cloud",
    label: "Databases & Services",
    accent: "orange",
    items: ["Cosmos DB", "Azure (Functions, Blob Storage)", "PlayFab", "Firebase", "Google Cloud"]
  }
];

export default skillGroups;
